export const MOBILE = "MOBILE";
export const DESKTOP = "DESKTOP";

export const imageCropModes = {
    [MOBILE]: "Mobile",
    [DESKTOP]: "Desktop",
};
